import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export const getdeliverypendings = option =>
  request3('v1/order/getdeliverypendings', option, true, false) // 查询待发货订单列表

export const getindeliverys = option =>
  request3('v1/order/getindeliverys', option, true, false) // 查询已发货订单列表

export const deliverorder = option =>
  request3('v1/order/deliverorder', option, true, false) // 订单发货

export const getorders = option =>
  request3('v1/order/getorders', option, true, false) // 查询全部订单

export const getexpresses = option =>
  request3('v1/logistics/getexpresses', option, true, false) // 查询物流公司列表

export const getorder = option => {
  const urls = urlStringify(option)
  return request3('v1/order/getorder' + urls, {}, true, false) // 查询单条订单
}

export default {
  // 下载待发货订单列表
  downloaddeliverypendings: options => {
    const urls = urlStringify(options)
    return request3(
      'v1/order/downloaddeliverypendings' + urls,
      {},
      true,
      false,
      true
    )
  },
  // 下载待发货订单模版
  downloaddeliveryordertemplate: options => {
    const urls = urlStringify(options)
    return request3(
      'v1/order/downloaddeliveryordertemplate' + urls,
      {},
      true,
      false,
      true
    )
  },
  // 上传图片
  deliverorders: option =>
    request3('v1/order/deliverorders', option, true, true),
  // 查询待发货订单列表
  getdeliverypendings: option =>
    request3('v1/order/getdeliverypendings', option, true),
  // 查询已发货订单列表
  getindeliverys: option => request3('v1/order/getindeliverys', option, true),
  // 查询物流公司列表
  getexpresses: option => request3('v1/logistics/getexpresses', option, true),
  // 订单发货
  deliverorder: option => request3('v1/order/deliverorder', option, true),
  // 查询全部订单
  getorders: option => request3('v1/order/getorders', option, true),
  closeorder: option => request3('v1/order/closeorder', option, true),
  // 查询退款/退货列表
  getorderreturns: option =>
    request3('v1/orderreturn/getorderreturns', option, true),
  // 退款/退货审核
  ackorderreturn: option =>
    request3('v1/orderreturn/ackorderreturn', option, true),
  // 退货审核
  agreeorderreturn: option =>
    request3('v1/orderreturn/agreeorderreturn', option, true),
  // 查询单条订单
  getorder: option => {
    const urls = urlStringify(option)
    return request3('v1/order/getorder' + urls, {}, true)
  },
  // 实时物流
  getorderdeliverytrace: option => {
    const urls = urlStringify(option)
    return request3('v1/order/getorderdeliverytrace' + urls, {}, true)
  }
}
